import { render, staticRenderFns } from "./loginNew.vue?vue&type=template&id=3e3a48b0&scoped=true"
import script from "./loginNew.vue?vue&type=script&lang=js"
export * from "./loginNew.vue?vue&type=script&lang=js"
import style0 from "./loginNew.vue?vue&type=style&index=0&id=3e3a48b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3a48b0",
  null
  
)

export default component.exports